import React from "react";
import "./DeleteCohortModel.scss";
import { Modal } from "react-bootstrap";
import exportimages from "../../../../assets/images/exportImages";
import { useDispatch } from "react-redux";
import { HttpStatusCode } from "axios";
import { useDeleteCohortMutation } from "../../../../rtk-query/features/cohort/cohortRTK";
import { setLoaderFalse, setLoaderTrue } from "../../../../Redux/loaderSlice";
import { setSelectedCohort } from "../../../../rtk-query/features/cohort/cohortSlice";

export const DeleteCohortModel = (props) => {
  const dispatch = useDispatch();
  const [deleteCohort, { isLoading }] = useDeleteCohortMutation();
  const handleDeleteCohort = async () => {
    dispatch(setLoaderTrue());
    const response = await deleteCohort({ cohortId: props?.uid });
    if (response?.data?.statusCode === HttpStatusCode.Ok) {
      props.onHide();
    }
    dispatch(setSelectedCohort(null));
    dispatch(setLoaderFalse());
  };
  return (
    <Modal
      {...props}
      animation="true"
      aria-labelledby="contained-modal"
      centered
      width="400px"
    >
      <Modal.Body className="cohort-modal">
        <div className="create-cohort-modal">
          <div class="modal-header">
            <div className="icon-outer-circle">
              <div className="icon-inner-circle">
                <img alt="icon" src={exportimages.delete_cohort_icon} />
              </div>
            </div>
          </div>
          <h2>Delete Cohort</h2>
          <p class="subtitle">
            Are you sure you want to delete this cohort? This action cannot be
            undone.
          </p>
          <div class="actions">
            <button class="btn cancel" onClick={() => props.onHide()}>
              Cancel
            </button>
            <button class="btn primary" onClick={handleDeleteCohort}>
              Delete
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
